module.exports = __webpack_public_path__ + "assets/2c17b9bf544b5bd3dcab2db994cf92f7.create_shift_person.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/create_shift_person.svg
 ** module id = 830
 ** module chunks = 1
 **/